import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import ViewReport from "./ViewReport";
import DeleteReport from "./DeleteReport";
import ExportCSVReport from "../../../../components/ExportCSVReport";
import { titleCase } from "../../../../config/Global";

interface DataType {
  index: number;
  id: string | any;
  number_type: string;
  from_date: string;
  to_date: string;
  response: string;
  created_date: string | any;
}

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
  } = props;

  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openUpdateData, setOpenUpdateData] = useState<any>();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  const handleDeleteRequestClose = (record: any) => {
    setOpenDeleteModal(false);
    setOpenDeleteData({});
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.id.toString().localeCompare(b.id),
    },
    {
      title: "From Date",
      dataIndex: "from_date",
      key: "from_date",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.from_date || "").localeCompare(b.from_date || ""),
      render: (_, record) => {
        return record?.from_date ? record?.from_date : "-";
      },
      fixed: "left",
    },
    {
      title: "To Date",
      dataIndex: "to_date",
      key: "to_date",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.to_date || "").localeCompare(b.to_date || ""),
      render: (_, record) => {
        return record?.to_date ? record?.to_date : "-";
      },
      fixed: "left",
    },
    {
      title: "Number Type",
      key: "number_type",
      dataIndex: "number_type",
      width: 200,
      fixed: "left",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.number_type.localeCompare(b.number_type),
      render: (_, record) => {
        return record?.number_type && titleCase(record?.number_type);
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a?.created_date || "").localeCompare(b?.created_date || ""),
      render: (_, record) => {
        return record?.created_date ? record?.created_date : "-";
      },
    },
    {
      title: "Action",
      key: "action",
      width: 200,
      // fixed: 'right',
      render: (_, record) => {
        const viewData = record?.response ? JSON.parse(record?.response) : null;

        return (
          <Space size="middle">
            <Tooltip title={"View Report"}>
              <Button
                type="default"
                icon={<EyeOutlined />}
                className="EditBtn iconBtn"
                onClick={() => handleViewReport(record)}
              />
            </Tooltip>
            <Tooltip title={"Export Report"}>
              {viewData && (
                <ExportCSVReport
                  elements={viewData.records}
                  reportName={`number-attributes-${record.number_type}-${Date.now()}`}
                  label={false}
                />
              )}
            </Tooltip>
            <Tooltip title={"Delete Report"}>
              <Button
                onClick={() => {
                  handleDeleteRequest(record);
                }}
                icon={<DeleteOutlined />}
                type="default"
                className="cancelBtn iconBtn"
              />
            </Tooltip>
            {/* <Tooltip title={'Delete Report'}>
                <Button
                  type='default'
                  icon={<DeleteOutlined />}
                  className='cancelBtn'
                  onClick={() => handleDeleteRequest(record)}>
                  Delete
                </Button>
              </Tooltip> */}
          </Space>
        );
      },
    },
  ];

  const numberAttributesData: DataType[] = listData?.map((item, index) => ({
    key: index.toString(),
    index: item.index,
    id: item._id,
    row_id: item._id,
    number_type: item?.number_type,
    from_date: item?.from_date,
    to_date: item?.to_date,
    response: item?.response,
    created_date: item?.created_date,
  }));

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const handleViewReport = (data: any) => {
    setOpenUpdateModal(!openUpdateModal);
    setOpenUpdateData(data);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={numberAttributesData}
          columns={columns}
          pagination={false}
          loading={tableloading}
        />
        <div className="text-center mt-20 mb-30 providerTable">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.current}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size}
            // showSizeChanger={totalData ? true : false}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>

      {openUpdateModal && (
        <ViewReport
          openUpdateModal={openUpdateModal}
          openUpdateData={openUpdateData}
          handleViewReport={handleViewReport}
        />
      )}

      <DeleteReport
        // title={openDeleteData?.id}
        title={"Report"}
        close={handleDeleteRequestClose}
        open={openDeleteModal}
        deleteValues={openDeleteData?.row_id}
        getList={getList}
      />
    </>
  );
};
export default ListTable;
